<!-- 开票状态 -->
<template>
  <div>
    <el-form-item label="开票状态"
                  prop="status">
      <template slot-scope="scope">
      <span v-for="item in options.status"
            v-if="form.status === item.value">{{ item.label }}</span>
      </template>
    </el-form-item>

    <el-form-item v-if="form.invoice_number"
                  prop="invoice_number"
                  label="发票号码">
      <span style="word-break: break-all;">{{ form.invoice_number }}</span>
    </el-form-item>

    <el-form-item v-if="form.invoice_code"
                  prop="invoice_code"
                  label="发票代码">
      <span style="word-break: break-all;">{{ form.invoice_code }}</span>
    </el-form-item>

    <el-form-item v-if="formatDate(form.invoice_time)"
                  prop="invoice_time"
                  label="开票日期">
      {{ formatDate(form.invoice_time) }}
    </el-form-item>

    <el-form-item v-if="form.e_invoice_url && form.e_invoice_url.length > 0"
                  prop="e_invoice_url"
                  label="发票文件">
      <AttachedFileList :files="form.e_invoice_url"/>
    </el-form-item>

    <el-form-item label="日志"
                  prop="log">
      <template>
        <div v-for="(item, index) in form.log">
          <span>{{ item.created_at }} {{ item.admin_name }}/{{ item.admin_real_name }} {{ item.desc }}</span>
        </div>
      </template>
    </el-form-item>

    <el-form-item label="附件"
                  prop="attached_file">
      <AttachedFileList :files="form.attached_file"/>
    </el-form-item>
  </div>
</template>

<script>
import AttachedFileList from './AttachedFileList'

export default {
  components: {
    AttachedFileList
  },
  props: {
    form: {},
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.invoiceApply.options,
    }),
  },
  data () {
    return {}
  },
  methods: {
    formatDate (date) {
      if (date && moment(date, 'YYYY-MM-DD HH:mm:ss').isValid()) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
  },
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceStatusLayout.vue